import React, { FC } from 'react';
import { ImageRenderer } from 'src/common/ImageRenderer';
import { useSpotlight } from 'src/common/spotlight/use-spotlight.hook';
import { formatDuration } from 'src/utils/date';

type EditorInsightsPdfChartTooltipProps = {
  show: boolean;
  x: number;
  y: number;
  page: number;
  totalPages: number;
  time: number;
  imageSrc: string;
  imageSrcSet: string;
};

export const EditorInsightsPdfChartTooltip: FC<EditorInsightsPdfChartTooltipProps> = ({
  show,
  x,
  y,
  page,
  totalPages,
  time,
  imageSrc,
  imageSrcSet,
}) => {
  const { anchorRef, renderSpotlight } = useSpotlight({
    offset: 16,
    placement: 'top',
    strategy: 'fixed',
  });

  const content = (
    <div className='w-[160px] flex flex-col'>
      <div className='flex justify-between'>
        <div className='text-bedrock-p'>Page</div>
        <div className='text-bedrock-p-strong'>
          {page}/{totalPages}
        </div>
      </div>
      <div className='flex justify-between'>
        <div className='text-bedrock-p'>Time spent</div>
        <div className='text-bedrock-p-strong'>
          {formatDuration(time, { format: 'minimal', returnEmptyIfZero: false, showAtleastMinutes: false })}
        </div>
      </div>
      <div className='flex mt-2'>
        <ImageRenderer
          src={imageSrc}
          srcSet={imageSrcSet}
          className='h-[200px]'
          showSpinnerOnLoading
          loadingClassName='bg-transparent h-[200px] m-auto top-[auto]'
        />
      </div>
    </div>
  );

  return (
    <div className='relative pointer-events-none'>
      <div
        ref={anchorRef}
        className='absolute'
        style={{
          top: `${y}px`,
          left: `${x}px`,
          width: '0px',
          height: '0px',
        }}
      ></div>
      {renderSpotlight({
        content: content,
        show,
        showDismissButton: false,
      })}
    </div>
  );
};
